import React from "react";
import useBreakpoint from "../../../../utils/useBreakpoint";
import { LandTourSurcharge } from "../../../../interfaces/land-tour.interface";
import GroundTourModal from "./GroundTourModal";

interface Props {
  open: boolean;
  onClose: () => void;
  surcharges: LandTourSurcharge[];
}

const formatAmount = (price: { price_type: string; amount_price: number; percentage?: number }) =>
  price.price_type === "percentage" ? `${price.percentage}%` : `RM ${Number(price.amount_price).toFixed(2)}`;

export default function SurchargesModal({ open, onClose, surcharges }: Props) {
  const isMobile = useBreakpoint();
  if (!open) return null;

  return (
    <GroundTourModal open={open} onClose={onClose} title="Surcharges" isMobile={isMobile}>
      <div className="ground-tour-show-v2__surcharges">
        {surcharges.map((surcharge) => (
          <div className="ground-tour-show-v2__surcharge" key={surcharge.id}>
            <h4>{surcharge.title}</h4>
            <ul>
              {surcharge.prices.map((price, index) => (
                <li key={index}>
                  {price.category}: {formatAmount(price)}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </GroundTourModal>
  );
}
